import { render, staticRenderFns } from "./ChatGpt-EmailTemplates.vue?vue&type=template&id=58c9b6fc&scoped=true"
import script from "./ChatGpt-EmailTemplates.vue?vue&type=script&lang=js"
export * from "./ChatGpt-EmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./ChatGpt-EmailTemplates.vue?vue&type=style&index=0&id=58c9b6fc&prod&lang=scss&scoped=true"
import style1 from "./ChatGpt-EmailTemplates.vue?vue&type=style&index=1&id=58c9b6fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9b6fc",
  null
  
)

export default component.exports